import * as React from "react";
import EntityShareModal from "components/permissions/EntityShareModal";
const UserFilterShareModal = ({ filter, toggleShareModalOpen }) => /* @__PURE__ */ React.createElement(
  EntityShareModal,
  {
    entityId: filter.id,
    entityType: "search_filter",
    entityTitle: filter.title || "No Title",
    description: "Search for a User or Team to add as collaborator on this search filter",
    onClose: toggleShareModalOpen,
    showShareableEntityURL: false,
    entityTypeTitle: "search filter"
  }
);
export default UserFilterShareModal;
